import { Component, input, forwardRef, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-capital-select',
  imports: [CommonModule],
  templateUrl: './capital-select.html',
  styleUrl: './capital-select.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CapitalSelect),
      multi: true
    }
  ]
})
export class CapitalSelect implements ControlValueAccessor {
  placeholder = input<string>("");
  options = input<string[]>([]); // Valores para el input
  displayOptions = input<string[]>([]); // Valores para mostrar en el dropdown (opcional)

  // Output para two-way binding
  valueChange = output<string>();

  isFocused: any = false;
  value: string = '';
  selectedDisplayValue: string = ''; // Valor a mostrar en el input cuando está seleccionado
  isDisabled = false;
  isInitialLoad = true;
  
  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: string): void {
    this.value = value || '';
    this.updateSelectedDisplayValue();
    // Desactivar flag después del primer render
    if (this.isInitialLoad && this.value) {
      setTimeout(() => {
        this.isInitialLoad = false;
      }, 0);
    }
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onSelectChange(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    const value = selectElement?.value;
    this.value = value;
    this.updateSelectedDisplayValue();
    this.onChange(value);
    // Detener la propagación para evitar que el click abra nuevamente el select
    event.stopPropagation();
  }

  onBlur(): void {
    this.isFocused = false;
    this.onTouched();
  }

  openSelect(event: Event, selectElement: HTMLSelectElement): void {
    // Si el click viene del select mismo, no hacer nada
    if (event.target === selectElement) {
      return;
    }
    
    if (!this.isDisabled) {
      selectElement.focus();
      // Intentar abrir el select en navegadores que lo soporten
      if (selectElement.showPicker) {
        selectElement.showPicker();
      } else {
        selectElement.click();
      }
    }
  }

  private updateSelectedDisplayValue(): void {
    if (!this.value) {
      this.selectedDisplayValue = '';
      return;
    }

    // Si NO hay displayOptions, mostrar el value directamente
    if (this.displayOptions().length === 0) {
      this.selectedDisplayValue = this.value;
      return;
    }

    // Si hay displayOptions, significa que options tiene los values y displayOptions tiene los labels
    // Buscar el índice del value en options y usar el label correspondiente de displayOptions
    const index = this.options().indexOf(this.value);
    if (index !== -1 && this.displayOptions()[index]) {
      this.selectedDisplayValue = this.displayOptions()[index];
    } else {
      this.selectedDisplayValue = this.value;
    }
  }
}
